<template>
    <div class="login-box-dialog">
      <div class="Detail-minProgram-panel">
        <div class="minProgram-panel">
          <div class="new-share-minImg">
            <img
              @click="close"
              class="close-btn"
              src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20220822/2022-08-22/5f5d31dc74ac3f4a2a3bf90e555aa4db.png"
              alt=""
            />
            <div class="title">验证手机号</div>
            <div class="file-box">
              <div class="file-input">
                <input
                  type="text"
                  v-model="sendData.phone"
                  placeholder="请输入手机号"
                />
              </div>
              <div class="fail-tip" v-if="phoneErr">
                {{ phoneErrText }}
              </div>
            </div>

            <!-- <div class="file-box">
              <div class="file-input">
                <input
                  type="text"
                  v-model="sendData.code"
                  placeholder="请输入验证码"
                />
                <span
                  :class="active ? 'send-btn active' : 'send-btn'"
                  @click="active ? '' : sendMsg()"
                  >{{ active ? "重新发送（" + time + "）" : sendText }}</span
                >
              </div>
              <div class="fail-tip" v-if="codeErr">{{ codeErrText }}</div>
            </div> -->

            <div class="footer">
              <span class="cancel-btn" @click="close">取消</span>
              <span class="confirm-btn" @click="pay">确定，继续支付</span>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import { getCode, checkCode } from "../utils/common";
import { Toast } from "vant";

let timer = null;

export default {
  props: {},
  data() {
    return {
      show: true,
      sendText: "发送验证码",
      active: false,
      sendData: {
        phone: "",
        code: ""
      },
      phoneErr: false,
      phoneErrText: "手机号格式不正确，请重新输入",
      codeErr: false,
      codeErrText: "验证码错误，请重新输入",
      time: 59
    };
  },
  methods: {
    // 确定去支付
    async pay() {
      let sendData = this.sendData || {};
      let { phone } = sendData;
      if (phone == "" || !phone) {
        this.phoneErrText = '请输入手机号'
        return (this.phoneErr = true);
      } else {
        this.phoneErr = false;
      }
      sendData.code = ''
      // if (!code || code === "") {
      //   return Toast("请输入验证码");
      // }
      try {
        let res = await checkCode(sendData); // 校验手机号及验证码如果成功直接绑定
        if (res) {
          this.codeErr = false;
          this.$emit("bindSuccess", this.sendData.phone);
        }
      } catch (err) {
        if(err == '手机号格式不正确') {
          this.phoneErr = true;
          this.phoneErrText = err || "手机号格式不正确，请重新输入";
          return 
        }
        this.codeErr = true;
        this.codeErrText = err || "验证码错误，请重新输入";
      }
    },
    // 点击发送验证码
    async sendMsg() {
      let { phone } = this.sendData;
      if (phone == "" || !phone) {
        this.phoneErrText = '请输入手机号'
        return (this.phoneErr = true);
      }
      try {
        let res = await getCode(this.sendData.phone);
        if (res) {
          this.phoneErr = false;
          this.countdown();
          this.active = true;
        }
      } catch (err) {
        this.phoneErr = true;
        this.phoneErrText = err || "手机号格式不正确，请重新输入";
      }
    },
    // 倒计时
    countdown() {
      timer = setInterval(() => {
        this.time -= 1;
        if (this.time <= 0) {
          clearInterval(timer);
          this.active = false;
          this.time = 59;
          return;
        }
      }, 1000);
    },
    close() {
      this.$emit("hideVisible");
    }
  }
};
</script>

<style lang="scss" scoped>
.Detail-minProgram-panel {
  .share-choice-mask {
    position: fixed;
    z-index: 101;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    background-color: rgba(0, 0, 0, 0.5);
  }

  .minProgram-panel {
    width: 100%;
    position: fixed;
    z-index: 102;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    justify-content: center;
    font-size: 14px;
    .new-share-minImg {
      position: relative;
      width: 100%;
      max-width: 500px;
      padding: 20px 15px 15px;
      background-color: #ffffff;
      border-radius: 4px 4px 0 0;
      box-sizing: border-box;
    }
    .close-btn {
      width: 20px;
      height: 20px;
      display: inline-block;
      position: absolute;
      top: 15px;
      right: 15px;
      cursor: pointer;
    }
    .title {
      font-size: 15px;
      font-weight: bold;
      margin-bottom: 15px;
    }
    .file-box {
      margin-bottom: 10px;
    }
    .file-input {
      height: 45px;
      line-height: 45px;
      background: #f8f8f8;

      padding: 0 15px;
      border-radius: 4px;
      display: flex;
      input {
        flex: 1;
        border: none;
      }
    }
    .fail-tip {
      font-size: 13px;
      color: #ff7070;
      margin-top: 5px;
    }
    .footer {
      margin-top: 10px;
      display: flex;
      height: 40px;
      line-height: 40px;
    }
    .send-btn {
      color: #1890ff;
      cursor: pointer;
      display: inline-block;
      text-align: right;
    }
    .send-btn.active {
      color: #999999;
      cursor: auto;
      min-width: 108px;
    }
    .cancel-btn {
      display: inline-block;
      padding: 0 15px;
      color: #999999;
      cursor: pointer;
    }
    .confirm-btn {
      flex: 1;
      text-align: center;
      background: #1890ff;
      color: #ffffff;
      border-radius: 4px;
      margin-left: 10px;
      cursor: pointer;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/getphone.vue